import { SourceApiType } from '@dav-model/api/source-api.type';
import { SurchargeType } from '@dav-model/form/option-type.model';

export class ProductDescription {
  enUsProductDescription: string;
  frCaProductDescription: string;
}

export class PlanName {
  enUsPlanName: string;
  frCaPlanName: string;
}

export class Label {
  enUsLabel: string;
  frCaLabel: string;
}

export class SurchargeOption {
  label: Label;
  value: string;
  key: string;
  surchargeAmount: number;
  surchargeMsrpAmount: number;
  editable: boolean;
  type: string | null;
  description: string | null;
  mandatory: boolean;
  obligatory: boolean; // non-optional option - should always be added
  added?: boolean = false;
  numberOfEngine: number | null;
  groupType: SurchargeType | null;
  sequence: number;
  category: SurchargeCategory;
}

export type SurchargeCategory =
  | 'Generator'
  | 'Sportsman/Fishing'
  | 'Trailer (With Core)'
  | 'Trailer (Standalone)'
  | 'Other';

export class SurchargeOptions {
  surchargeOption: SurchargeOption[];
}

export class PlanName2 {
  en_us_planName: string;
}

export class ChildProduct {
  productType: string;
  planCode: string;
  planName: PlanName2;
}

export class ChildProducts {
  childProduct: ChildProduct[];
}

export class ProductItem {
  dealer?: string;
  vendor?: string;
  productType: string;
  productCode: string;
  productCategory: string;
  productDescription: ProductDescription;
  planCode: string;
  planName: PlanName;
  planSKU: string;
  usageType: string;
  minTerm: string;
  maxTerm: string;
  isBundled: boolean;
  isDiscounted: boolean;
  termMileage: string;
  termInput?: string;
  deductible: string;
  reducingDeductible: boolean;
  vehicleClass: string;
  financeAmountFrom: string;
  financeAmountTo: string;
  msrpTo: string;
  msrpFrom: string;
  vehicleSellingPriceFrom: string;
  vehicleSellingPriceTo: string;
  grossCapCostFrom: string;
  grossCapCostTo: string;
  dealerCost: number;
  retailRateType: string;
  retailRate: number;
  surchargeOptions: SurchargeOptions;
  startingInterval: string;
  formNumber: string;
  formDescription: string;
  vehicleClassing: string;
  coverageCode: string;
  coverageDescription: string;
  coverageOptions: { coverageOption: string[] };
  minDollarAmount: string;
  maxDollarAmount: string;
  paymentType: string;
  startingIntervalName: string;
  minOdometer: string;
  maxOdometer: string;
  programType: string;
  planType: string;
  childProducts: ChildProducts;
  taxes?: Tax;
  externalProductReferenceCode?: string;
  vehicleCondition?: string;
  sourceApi: SourceApiType;

  // retail error handler
  customerCost?: number;
  costPlaceholder?: number = 0;
  totalCost?: number;

  // taxes
  qstTax?: number;
  gstTax?: number;
  pstTax?: number;
  hstTax?: number;

  // for display purposes
  surchargeAdded?: boolean;

  // for display purposes - used for taxes
  displayCost?: number;
  customerTerm?: number;
  customerTermError?: boolean;
  errorFlag?: boolean;
  errorMessage?: string;

  //slots to use in the UI logic
  unique?: string;
  isAddedToCart?: boolean;
}

export class Products {
  productItem: ProductItem[];
}

export class AvailableOptions {
  dealer: string;
  vin: string;
  vehicleMake: string;
  vehicleModel: string;
  vehicleYear: string;
  financeAmount: string | number;
  saleDate: string;
  inServiceDate: string;
  isAfterSale: string;
  vehiclePurchaseDate: string;
  vehicleTrim?: string;
  financeType: string;
  vehicleCondition: string;
  vehicleCost: string;
  msrp?: string;
  programName: string;
  products: Products | null;
  vehicleMSRP?: string;
}

export class StandardResponse {
  status: string;
  responseCode: string;
  responseDescription: string;
}

export class GetProductsResponse {
  availableOptions: AvailableOptions;
  standardResponse: StandardResponse;
}

// tax models
export class Taxes {
  customer: Tax;
  dealer: Tax;
}

export class Tax {
  sgTaxCalcDate: string;
  sgTaxCode: string;
  sgTaxContract: string;
  sgTaxSeq: string;
  sgTaxSource: string;
  sgTaxTotal: number;
  sgTaxTotalAmt: number;
  statusMessage: string;
  uniqueId: number;
  taxes: IndividualTax[];
}

export class IndividualTax {
  sgTaxAmt_0: number;
  sgTaxBased_0: string;
  sgTaxCode_0: string;
  sgTaxDisp_0: string;
  sgTaxExemp_0: string;
  sgTaxOverPct_0: number;
  sgTaxOverride_0: string;
  sgTaxPct_0: number;
}
